import request from "@/util/request";

export function xdahsdkadhjads(data) {
    return request({
        url: '/api/xdahsdkadhjads/'+ Date.now() + Math.random(),
        method: 'post',
        data
 })
}

export function ip() {
    return request({
        url: '/api/xisap',
        method: 'post'
    })
}

export function create(data) {
    return request({
        url: '/api/payment/create',
        method: 'post',
        data
 })
}
